export default function displayCurrency(value, currencyCode) {
  return parseFloat(value).toLocaleString('en-GB', {
    style: 'currency',
    currency: currencyCode || 'GBP',
  });
}
